"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeAtomFamily = void 0;
const utils_1 = require("jotai/utils");
const util_1 = require("../util");
const safeAtomFamily = (initializeAtom, areEqual) => {
    let family = null;
    const initializeAtomWrapper = (param) => {
        const atom = initializeAtom(param);
        if (typeof window === 'undefined') {
            util_1.PendingQueue.instance.push(() => {
                family?.remove(param);
            });
        }
        return atom;
    };
    family = (0, utils_1.atomFamily)(initializeAtomWrapper, areEqual);
    return family;
};
exports.safeAtomFamily = safeAtomFamily;
